import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SeriesCount from 'components/SeriesCount';
import { Container, Row, Column } from 'components/Grid';
import { HeaderContext } from 'components/Header/headerContext';
import { RegionSelectorButton } from '../MobileRegionSelector';
import { StudioSelectorButton } from '../MobileStudioSelector';

const StyledRegionSelectorButton = styled(RegionSelectorButton)`
  border: 0;
  outline: 0;

  > div {
    max-width: 7.5rem;

    & span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &:focus:enabled,
  &:hover,
  &.active {
    &::before {
      background-color: ${(props) => props.theme.colors.grayscale.black};
      content: '';
      display: block;
      height: 0.25rem;
      position: absolute;
      top: -1.2rem;
      width: calc(100% - 1rem);
    }
  }
`;

function MobileSeriesOptions({
  id,
  activeState,
  activeRegion,
  regionClick,
  studiosClick,
  showBookBikeButton,
}) {
  const headerContext = useContext(HeaderContext);
  const { seriesCount, userBadgeProps, showSeriesCount } = headerContext;
  const mb = showBookBikeButton ? '1rem' : '0';

  return (
    <Container width={1} px="1rem">
      <Row mb={mb} mx="0" alignItems="center" justifyContent="space-between">
        <div>
          {userBadgeProps && userBadgeProps.user && showSeriesCount ? (
            <SeriesCount
              id={`${id}-series-count`}
              count={seriesCount}
              text="Series"
            />
          ) : null}
        </div>
        <StyledRegionSelectorButton
          id={`${id}-region-selector`}
          selectedItem={activeRegion}
          onClick={regionClick}
          isOpen={activeState === 'region'}
          className={activeState === 'region' ? 'active' : ''}
        />
      </Row>
      <Row>
        <Column width={1}>
          {showBookBikeButton && (
            <StudioSelectorButton
              id={`${id}-bookbike`}
              onClick={studiosClick}
              isOpen={activeState === 'studios'}
            />
          )}
        </Column>
      </Row>
    </Container>
  );
}

MobileSeriesOptions.propTypes = {
  activeState: PropTypes.string.isRequired,
  activeRegion: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.string,
  regionClick: PropTypes.func.isRequired,
  studiosClick: PropTypes.func.isRequired,
  showBookBikeButton: PropTypes.bool,
};

MobileSeriesOptions.defaultProps = {
  id: 'mobile-series-options',
  showBookBikeButton: true,
};

export default MobileSeriesOptions;
